export default __webpack_public_path__ + "static/privacy-illustration-dark-0062c688e65a67b2181b4d4646a53301.svg";